import { OpenInNewOutlined } from '@mui/icons-material'
import { IconButton } from '@mui/material'

type Props = {
  href: string
}

export const ReportLinkButton = ({ href }: Props): React.JSX.Element => (
  <IconButton
    href={href}
    rel='noopener noreferrer'
    size='small'
    target='_blank'
  >
    <OpenInNewOutlined />
  </IconButton>
)
